import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { legalComplaint } from "../../../../configration_data/configration";
import ProtectedPaymentRoute from "../../../../auth/Auth";

export default function LegalCompliant() {
  ProtectedPaymentRoute();

  const navigate = useNavigate();

  const clicknext = (e) => {
    e.preventDefault();
    navigate("/register_agent_corpo");
  };

  const backbtn = () => {
    navigate("/corp_question/5");
  };

  const handleNextPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      clicknext(e);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleNextPress);
    return () => {
      document.removeEventListener("keydown", handleNextPress);
    };
  }, []);

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-5xl">
        <div className="mb-10 text-center max-w-3xl mx-auto">
          <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
            Corporate Compliance Advisory
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Keep your corporation legally compliant to avoid setbacks
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Protect your corporate veil with mandatory annual filings, board minutes maintenance, and regulatory monitoring.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {legalComplaint.map((ele) => (
            <div
              key={ele.title}
              className="p-6 rounded-[12px] border border-[#dadce0] bg-white hover:border-[#1a73e8]/40 hover:shadow-md transition-all flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] mb-5 text-xl">
                <i className={ele.icon} aria-hidden="true"></i>
              </div>
              <h4 className="text-[17px] font-medium text-[#202124] mb-2">
                {ele.title}
              </h4>
              <p className="text-[14px] text-[#5f6368] leading-relaxed">
                {ele.pera}
              </p>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-6 border-t border-[#f1f3f4] max-w-5xl mx-auto">
          <button
            type="button"
            onClick={backbtn}
            className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
          >
            <i className="fa-solid fa-arrow-left text-xs"></i> Back
          </button>
          <button
            type="button"
            onClick={clicknext}
            className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
          >
            Next <i className="fa-solid fa-arrow-right text-xs"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
